module.exports = __webpack_public_path__ + "static/2-fa82466c2e434333443ec996f7a12151.jpg";